<template>
  <v-layout row wrap align-center align-content-center justify-center>
    <v-flex md12>
      <v-flex md8>
        <v-select
          v-if="isManagement"
          :items="vendorsList"
          item-text="name"
          item-value="id"
          v-model="selectedVendor"
          placeholder="Select the vendor"
        ></v-select>
      </v-flex>
      <v-layout md8>
        <v-flex md6>
          <v-text-field
            type="file"
            accept=".jpg,.png,.doc,.docx,.pdf,.xls,.xlsx"
            @change.native="onInvoiceFileChange"
          ></v-text-field>
        </v-flex>
        <v-flex md2>
          <v-btn
            type="submit"
            block
            @click="uploadInvoice"
          >Upload</v-btn>
        </v-flex>
      </v-layout>
    </v-flex>

    <AppMainDialog :open="dialogOpen" :message="dialogMessage" @closedialog="dialogOpen = false"></AppMainDialog>
  </v-layout>
</template>

<script>
  // import CrudAPI from '@/api/resources/crud'
  import invoiceAPI from '@/api/invoice'
  import usersAPI from '@/api/user'
  import AppMainDialog from '@/components/AppMainDialog'

  // const DFS_INVENTORY = 1
  // const DFS_SERVICE = 2

  export default {
    components: { AppMainDialog },
    data () {
      return {
        vendorsList: [],
        vendorsInventories: [],
        vendorsServices: [],
        selectedVendor: null,
        invoiceFile: null,
        dialogMessage: '',
        dialogOpen: false
      }
    },
    props: {
      id: {
        required: true
      }
    },
    computed: {
      isManagement () {
        return this.$store.getters.currentUserRoles.some(item => ['case-manager', 'management'].includes(item))
      }
    },
    methods: {
      uploadInvoice () {
        // let vendorType = this.selectedVendor.split('|')

        let formData = new FormData()

        // this.selectedVendor = vendorType[0]

        formData.append('invoice_file', this.invoiceFile)
        formData.append('vendor_id', this.selectedVendor)
        formData.append('vendor_type', 2) // 1 is inventory; 2 is service
        // formData.append('vendor_type', vendorType[1]) // 1 is inventory; 2 is service

        let upload = invoiceAPI.uploadInvoice(formData, this.id)

        upload.then(result => {
          this.$bus.$emit('invoice:uploaded')

          this.dialogMessage = 'Invoice successfully uploaded'

          this.dialogOpen = true
        }, error => {
          this.dialogMessage = 'Error happened, try again'

          this.dialogOpen = true

          let handle = error // eslint-disable-line
        })
      },
      onInvoiceFileChange (event) {
        this.invoiceFile = event.target.files[0]
      }
    },
    created () {
      if (this.isManagement) {
        usersAPI.loadVendors().then(result => {
          this.vendorsList = result
        }, () => {})
      }

      this.selectedVendor = this.$store.getters.currentUser.id
      // let vendorsInventories = CrudAPI.dfsResourceIndex('inventories/vendors')
      // let vendorsServices = CrudAPI.dfsResourceIndex('services/vendors')
      //
      // vendorsInventories.then(result => {
      //   result.forEach((item, i) => {
      //     item.text = item.name + '[INVENTORY]'
      //     item.value = item.id + '|' + DFS_INVENTORY
      //   })
      //
      //   this.vendorsInventories = result
      //
      //   this.vendorsList = this.vendorsList.concat(this.vendorsInventories)
      // }, error => {
      //   let handle = error // eslint-disable-line
      // })
      //
      // vendorsServices.then(result => {
      //   result.forEach((item, i) => {
      //     item.text = item.name + '[SERVICE]'
      //     item.value = item.id + '|' + DFS_SERVICE
      //   })
      //
      //   this.vendorsServices = result
      //
      //   this.vendorsList = this.vendorsList.concat(this.vendorsServices)
      // }, error => {
      //   let handle = error // eslint-disable-line
      // })
    }
  }
</script>



// WEBPACK FOOTER //
// VendorsInvoice.vue?fa86fe3a